import {Component, Input, OnInit} from '@angular/core'
import {CookieService} from 'ngx-cookie-service'

@Component({
  selector: 'dmmp-website-cookies',
  templateUrl: './website-cookies.component.html'
})
export class WebsiteCookiesComponent implements OnInit {
  @Input() module

  constructor(public cookieService: CookieService) {
  }

  ngOnInit() {
  }

  validateCookie() {
    const dateNow = new Date()
    dateNow.setDate(dateNow.getDate() + 180)
    this.cookieService.set(
      'politicaDatos',
      'true',
      dateNow,
      '/'
    )
  }
}
